import React from 'react';
import FooterBannerComponent from "./FooterBannerComponent";
import FooterContentComponent from "./FooterContentComponent";


const FooterHomeComponent: React.FC = ({}) => {
    return (
        <div style={{display: 'flex', flexDirection: 'column'}}>
            <FooterContentComponent/>
            <FooterBannerComponent/>
        </div>
    );
};

export default FooterHomeComponent;
